module.exports = __webpack_public_path__ + "img/leftside_300.30c4ea32.png";